import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { useSyncState } from '@/hooks/useSyncState';

/** Small always-visible connectivity / pending-delivery indicator. */
export function SyncStatus() {
  const online = useNetworkStatus();
  const { pending, running } = useSyncState();

  let label: string;
  let styles: string;

  if (!online) {
    label = 'Offline';
    styles = 'bg-slate-200 text-slate-700';
  } else if (running) {
    label = 'Syncing…';
    styles = 'bg-brand-100 text-brand-800';
  } else if (pending > 0) {
    label = `Pending Sync (${pending})`;
    styles = 'bg-amber-100 text-amber-900';
  } else {
    label = 'Online';
    styles = 'bg-emerald-100 text-emerald-900';
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${styles}`}
      role="status"
      aria-live="polite"
    >
      <span aria-hidden="true">{online ? '●' : '○'}</span>
      {label}
    </span>
  );
}
